const UrlName = '/course/v1/open'
export default API => ({
    // 获取目录
    findCourseItemByCourseId({data, params}) {
        return API({ url: `${UrlName}/courseItem/getValidCourseItemInfo`, params, data });
    },
    // 获取课程详情
    findCourseInfo({data, params}) {
        return API({ url: `${UrlName}/course/findCourseInfo`, params, data });
    },
    // 最近学习
    getRecentPlayCourse({data, params}) {
        return API({ url: `${UrlName}/course/getRecentPlayCourse`, params, data });
    },
    // 观看课程信息保存
    postCourseLearningLogSaveLog({data, params}) {
        return API({ url: `${UrlName}/courseLearningLog/saveLog`, method:'post', params, data });
    },
    // 记录当前用户的学习时长
    postUserLearningLog({data, params}) {
        return API({ url: `/bi/v1/statistics/timingNotify`, method:'post', params, data });
    },
    //考试中-试题信息
    findQuestForExam(params) {
        return API({ url: '/exam/v1/userPaper/findQuestForExam', method: 'get', params});
    },
    // 单次提交试卷答案
    commitPaper({data, params}) {
        return API({ url: '/exam/v1/userPaper/commitPaper', method: 'post', params, data });
    },
    // 整体提交试卷答案
    commitAllPaper({data, params}) {
        return API({ url: '/exam/v1/userPaper/commitAllPaper', method: 'post', params, data });
    },
    // 单次考试结果-详情
    findUserPaperInfo(params) {
        return API({ url: '/exam/v1/userPaper/findUserPaperInfo', method: 'get', params});
    },
    startexam({data, params}){
        return API({ url: `train/v1/train/student/findComingExam`, params, data });        
    },
    reading(id){
        return API({ url: `/exam/v1/exam/findById?id=${id}`,method:  'get',});
    },
    // findTrainExamInfoById({data, params}) {
    //     return API({ url: `/train/v1/trainItemExam/findTrainExamInfoById`, params, data });
    // },
    findExamListByIds({data, params}){
        return API({ url: `/exam/v1/exam/findExamListByIds`, params, data });
    },
    //  findUserPaperListById({data, params}) {
    //     return API({ url: `/train/v1/trainItemExam/findUserPaperListById`, params, data });
    // },
    findUserPaperListById({data, params}) {
        return API({ url: `/exam/v1/userPaper/findUserPaperListById`, params, data });
    },
    // findUserPaperSurface({data, params}) {
    //     return API({ url: `exam/v1/userPaper/findUserPaperSurface`, params, data });
    // },
    findUserPaperSurface(params) {
        return API({ url: '/exam/v1/userPaper/findUserPaperSurface', method: 'get', params});
    },
    joinexam({data,params}){
        return API({ url: `/exam/v1/exam/joinExam`,method:  'get',data,params});
    },
    isRealNameAuthentication({data, params}) {
        return API({ url: '/monitor/v1/user/oauth/isRealNameAuthentication', method: 'post', params, data });
    },
    // 加入指定练习，返回用户试卷ID
    userPracticejoinExam({data, params}) {
        return API({ url: '/exam/v1/userPractice/joinExam', params, data });
    },
    // 轮询，记录在线人数
    sendHeartbeat(params){
        return API({
          url: `/exam/v1/data/sendHeartbeat`,
          method:'get',
          params
        });
    },
    // 获取考试基础信息
    findBasicExamById({data,params}){
        return API({
            url:`/exam/v1/exam/findBasicExamById`,
            data,
            params,
            method:'get',
        })
    },
})
